import {
  GROUP_LIST_GET,
  CUR_GROUP_GET,
  PRIVILIGE_LIST_GET,
  MANAGER_USER_LIST,
  USER_JOB_PRIVILEGE_GET,
} from "../../fetch/url";
import { get } from '../../fetch/fetch';
import { actionTypes } from "./constants";
import { curl } from 'zh-common-modules';
  
export const setGroupList = data => ({
  type: actionTypes.SET_GROUPLIST,
  data
});

export const setCurGroup = data => ({
  type: actionTypes.SET_CURGROUP,
  data
});

export const setPrivilegeList = data => ({
  type: actionTypes.SET_PRIVILEGELIST,
  data
});

export const setManagerList = data => ({
  type: actionTypes.SET_MANAGERLIST,
  data
});

export const setManagerListStrId = data => ({
  type: actionTypes.SET_MANAGERLIST_STR_ID,
  data
});

export const setMessage = data => ({
  type: actionTypes.SET_MESSAGE,
  data
});


export const setJobPrivilege = data => ({
  type: actionTypes.SET_JOB_PRIVILEGE,
  data
});

export const getGroupList = (params) => {
  return dispatch => {
    get(GROUP_LIST_GET, params)
      .then(res => {
        if (res.success) {
          const data = res.content;
          dispatch(setGroupList(data.rows));
        }
      })
      .catch(() => {
        dispatch(setMessage({
          type: 'error',
          msg: '获取角色列表失败！',
        }));
      });
  };
};

export const getManagerList = (params, cb) => {
  return dispatch => {
    get(MANAGER_USER_LIST, params)
      .then(res => {
        if (res.success) {
          const data = res.content;
          const { rows = [] } = data;
          cb?.(data);
          const rowsStrId = rows.map(_row => ({ ..._row, id: _row.id + "" }));
          dispatch(setManagerList({
            list: data.rows,
            total: data.total,
          }));

          dispatch(setManagerListStrId({
            list: rowsStrId,
            total: data.total,
          }));
        }
      })
      .catch(() => {
        dispatch(setMessage({
          type: 'error',
          msg: '获取用户列表失败！',
        }));
      });
  };
};

export const getPrivilegeList = (cb) => {
  return dispatch => {
    get(PRIVILIGE_LIST_GET)
      .then(res => {
        if (res.success) {
          const data = res.content;
          dispatch(setPrivilegeList(data.rows));
          cb?.(data.rows);
        }
      })
      .catch(() => {
        dispatch(setMessage({
          type: 'error',
          msg: '获取权限列表失败！',
        }));
      });
  };
};

export const getCurGroup = (params) => {
  return dispatch => {
    get(CUR_GROUP_GET, params)
      .then(res => {
        if (res.success) {
          const data = res.content;
          dispatch(setCurGroup(data));
        }
      })
      .catch(() => {
        dispatch(setMessage({
          type: 'error',
          msg: '获取角色详情失败！',
        }));
      });
  };
};

export const getJobPrivilege = (params) => {
  return dispatch => {
    curl
      .get(USER_JOB_PRIVILEGE_GET, params)
      .then((res) => {
        dispatch(setJobPrivilege(res));
      });
  };
};